module.exports = __webpack_public_path__ + "static/media/no-license.b518c655.png";